import { MEDIA_LIBRARY_MODAL_SEARCH_SLOT_ID } from '../../../MediaLibraryModal/MediaLibraryModalQueryContext';

const CATALOG_SEARCH_SLOT_ID = 'search-input';

export default function getSearchInputPortalTarget(isMediaLibraryModal) {
  if (typeof document === 'undefined') return null;
  return document.getElementById(
    isMediaLibraryModal ? MEDIA_LIBRARY_MODAL_SEARCH_SLOT_ID : CATALOG_SEARCH_SLOT_ID,
  );
}
